import { FC } from 'react';
import { Block } from './ShowFromRight.style';

export const ShowFromRight: FC<{ elementsCount?: number }> = ({ children }) => {
  return <Block>{children}</Block>;
};
